import { Box, Column, Divider } from 'braid-design-system';

import * as styles from './DividerColumn.css';

export const DividerColumn = ({
  horizontalToVerticalBreakpoint,
  hideHorizontal,
}: {
  horizontalToVerticalBreakpoint: 'tablet' | 'desktop';
  hideHorizontal?: boolean;
}) => (
  <>
    <Column width="content" hideBelow={horizontalToVerticalBreakpoint}>
      <Box className={styles.verticalDivider} />
    </Column>
    {hideHorizontal ? null : (
      <Column
        width="content"
        hideAbove={
          horizontalToVerticalBreakpoint === 'tablet' ? 'mobile' : 'tablet'
        }
      >
        <Divider />
      </Column>
    )}
  </>
);
